<template>
    <div class="side-bar-toggle-btn">
        <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
            <div class="offcanvas-header profil-head">
                <div class="join-btn-offcanvas-sec">
                    <div v-if="checkIsLogin()" class="join-now-btn v-avatar">
                        <div class="v-avatar-img">
                            <span>{{ userData?.userid[0].toUpperCase() }}</span>
                        </div>
                        <div class="text-truncate ms-2">
                            Hi, {{ userData?.userid }}
                        </div>
                    </div>

                    <div v-else class="join-now-btn">
                        <img :src="siteSettings?.aws_url + siteSettings?.storage_path.domain_image + siteSettings?.logo" alt="logo" class="web-logo" /><br/>
                        <router-link to="/sign-up" @click="closeModal()" class="cmn-btn123">Register</router-link>
                    </div>

                    <!-- <div class="select-language-model-pop-up">
                        <a href="#language_selection_pop_up" data-bs-toggle="modal">Select laguage<i
                                class="fa-solid fa-angle-down"></i></a>
                    </div> -->
                </div>
                <div style="display: none;" ref="close_modal"  data-bs-dismiss="offcanvas"
                    aria-label="Close"></div>
            </div>
            <div class="offcanvas-body">
                <div class="market">
                    <div class="row">
                        <div class="col-12">
                            
                            <router-link to="/markets" @click="closeModal()">
                                <div class="markets-and-news-sec">
                                    <img loading="lazy" src="@/assets/images/market.webp" alt="">
                                    <span>Market</span>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-12">
                            <router-link to="/static/NEWS" @click="closeModal()">
                                <div class="markets-and-news-sec">
                                    <img loading="lazy" src="@/assets/images/news.webp" alt="">
                                    <span>News</span>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-12">
                            <router-link to="/static/ABOUT_US" @click="closeModal()">
                                <div class="markets-and-news-sec">
                                    <img loading="lazy" src="@/assets/images/about-us.webp" alt="">
                                    <span>About Us</span>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-12">
                            <router-link to="/static/TUTORIALS" @click="closeModal()">
                                <div class="markets-and-news-sec">
                                    <img loading="lazy" src="@/assets/images/help.webp" alt="">
                                    <span>Tutorials</span>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-12">
                            <router-link to="/static/PRIVACY_POLICY" @click="closeModal()">
                                <div class="markets-and-news-sec">
                                    <img loading="lazy" src="@/assets/images/privacy.webp" alt="">
                                    <span>Privacy Policy</span>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-12">
                            <router-link to="/faqs" @click="closeModal()">
                                <div class="markets-and-news-sec">
                                    <img loading="lazy" src="@/assets/images/faqs.webp" alt="">
                                    <span>FAQ</span>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-12">
                            <router-link to="/static/PROMOTIONS" @click="closeModal()">
                                <div class="markets-and-news-sec">
                                    <img loading="lazy" src="@/assets/images/promotions.webp" alt="">
                                    <span>Promotions</span>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12">
                        <router-link to="/affiliate" @click="closeModal()">
                            <div class="markets-and-news-sec">
                                <img loading="lazy" src="@/assets/images/affiliate.webp" alt="">
                                <span>Affiliate</span>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-12">
                        <router-link to="/static/TERM_CONDITIONS" @click="closeModal()">
                            <div class="markets-and-news-sec">
                                <img loading="lazy" src="@/assets/images/terms-and-conditions.webp" alt="">
                                <span>T&C</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="online-betting-app-btn">
                    <a href="#install-apk-model" data-bs-toggle="modal">
                        <div class="down-app-btn">
                            <span>Download App</span>
                        </div>
                    </a>
                </div>
                <div class="remove-padding" v-if="checkIsLogin()">
                    <div class="row">
                        <div class=""  v-if="siteSettings?.social_link">
                            <div class="socail-link">
                                <ul>
                                    <li v-if="siteSettings.social_link.facebook_link"><a :href="siteSettings.social_link.facebook_link" target="_blank"><img loading="lazy" src="@/assets/images/facebook.webp" alt=""></a></li>
                                    <!-- <li><a href="#"><img loading="lazy" src="@/assets/images/twitter.webp" alt=""></a></li> -->
                                    <li v-if="siteSettings.social_link.telegram_link"><a :href="siteSettings.social_link.telegram_link" target="_blank"><img loading="lazy" src="@/assets/images/telegram.webp" alt=""></a></li>
                                    <li v-if="siteSettings.social_link.instagram_link"><a :href="siteSettings.social_link.instagram_link" target="_blank"><img loading="lazy" src="@/assets/images/instagram.webp" alt=""></a></li>
                                    <li v-if="siteSettings.social_link.youtube_link"><a :href="siteSettings.social_link.youtube_link" target="_blank"><img loading="lazy" src="@/assets/images/youtube.webp" alt=""></a></li>
                                    <li v-if="siteSettings.social_link.email"><a :href="'mailto:'+ siteSettings.social_link.email" target="_blank"><img loading="lazy" src="@/assets/images/email.webp" alt="" style="border-radius:0"></a></li>
                                    <li v-if="siteSettings && siteSettings?.business_type == 2">
                                        <a :href="'//wa.me/'+siteSettings.social_link.whatsappno1" target="_blank" 
                                            v-if="siteSettings.social_link.whatsappno1">
                                            <img loading="lazy" src="@/assets/images/whatsapp.webp" alt="">
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <DownloadApkModal />
</template>

<script>
import DownloadApkModal from '@/shared/components/modal/DownloadApkModal.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'SideMenu',
    components: {
        DownloadApkModal
    },
    data() {
            return {
                userData: null
            }
        },
        mounted() {
            this.userData = this.$store?.getters?.stateUser;            
        },
        computed: {
         ...mapGetters({
            siteSettings: 'siteSettings' , stateUser : 'stateUser'
        })
      },
    methods:{
        checkIsLogin() {
			return this.$store.getters.isAuthenticated;
		},
        closeModal(){
            this.$refs.close_modal.click();
        }
    }
}
</script>